import { Pipe, PipeTransform } from '@angular/core';
import { BankName } from '../service/bank.service';

@Pipe({
  name: 'translateBankName'
})
export class TranslateBankNamePipe implements PipeTransform {
  bankName = {
    Ansar: 'بانک انصار',
    Ayandeh: 'بانک آینده',
    Bank_Markazi: 'بانک مرکزی',
    Dey: 'بانک دی',
    Eghtesad_Novin: 'بانک اقتصاد نوین',
    Gardeshgari: 'بانک گردشگری',
    Ghavamin: 'بانک قوامین',
    Hekmat: 'بانک حکمت ایرانیان',
    Iran_Zamin: 'بانک ایران زمین',
    Karafarin: 'بانک کارآفرین',
    Keshavarzi: 'بانک کشاورزی',
    Khavar_Mianeh: 'بانک خاورمیانه',
    Kosar: 'موسسه اعتباری کوثر',
    Maskan: 'بانک مسکن',
    Mehr_Eghtesad: 'بانک مهر اقتصاد',
    Mehr_Iran: 'بانک قرض الحسنه مهر ایران',
    Melall: 'مؤسسه اعتباری ملل (عسکریه سابق)',
    Mellat: 'بانک ملت',
    Melli: 'بانک ملی',
    Parsian: 'بانک پارسیان',
    Pasargad: 'بانک پاسارگاد',
    Postbank: 'پست بانک ایران',
    Refah: 'بانک رفاه کارگران',
    Resalat: 'بانک قرض الحسنه رسالت',
    Saderat: 'بانک صادرات ایران',
    Saman: 'بانک سامان',
    Sanat_Madan: 'بانک صنعت و معدن',
    Sarmayeh: 'بانک سرمایه',
    Sepah: 'بانک سپه',
    Shahr: 'بانک شهر',
    Sina: 'بانک سینا',
    Tejarat: 'بانک تجارت',
    Tosee: 'موسسه اعتباری توسعه',
    Tosee_Saderat: 'بانک توسعه صادرات ایران',
    Tosee_Taavon: 'بانک توسعه تعاون'
  };

  transform(value: BankName): string {
    return this.bankName[value];
  }
}
